import { createFileRoute, redirect } from '@tanstack/react-router';

import { EdoSettingsPage } from '../../../features/edo/ui/edo-settings-page.tsx';
import { orpc } from '../../../lib/orpc.ts';
import { permissionCheck } from '../../../lib/permissions.ts';
import { meQuery } from '../../../lib/session.ts';

export interface EdoSearch {
  /** Итог возврата входа через Контур: `ok` — вошли. */
  readonly login?: 'ok' | undefined;
  /** Код ошибки входа — текст берётся из словаря. */
  readonly login_error?: string | undefined;
}

export const Route = createFileRoute('/_app/settings/edo')({
  validateSearch: (search: Record<string, unknown>): EdoSearch => ({
    login: search.login === 'ok' ? 'ok' : undefined,
    login_error:
      typeof search.login_error === 'string' && /^[a-z_.]{1,64}$/.test(search.login_error)
        ? search.login_error
        : undefined,
  }),
  // ЭДО — `documents.templates` (ключи, пауза) и подписант студии (вход через Контур, сертификат).
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.query({ ...meQuery, staleTime: 'static' });
    if (permissionCheck(me.permissions).can('documents.templates')) return;
    const studio = await context.queryClient.query(orpc.org.studio.get.queryOptions()).catch(() => null);
    if (studio?.signerUserId !== me.id) throw redirect({ to: '/settings/notifications', replace: true });
  },
  component: EdoSettingsRoute,
});

function EdoSettingsRoute() {
  const search = Route.useSearch();
  return <EdoSettingsPage login={search.login ?? null} loginError={search.login_error ?? null} />;
}
